import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { facebook, instagram, yelp, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/todineforeatery/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="To Dine For Eatery Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/todineforeatery333/?max_id=1594366596700105026"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="To Dine For Eatery Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#FF7474" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            <CFLink
              target="_blank"
              href="https://www.facebook.com/todineforeatery/"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="To Dine For Eatery Facebook"
              />
            </CFLink>
            <CFLink
              target="_blank"
              href="https://www.instagram.com/todineforeatery333/?max_id=1594366596700105026"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="To Dine For Eatery Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
